import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useCallback, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { Icon } from '../Icon';
import { SwatchPickerContext } from '../SwatchPicker/SwatchPickerContext';
import { SwatchPickerDesign, } from '../SwatchPicker/SwatchPickerDesign';
const filterChipContainerHeight = 40;
const iconContainerStyles = css `
  padding-left: ${theme.spacing.x2};
  display:flex;
  align-items: center;
`;
const labelStyles = css `
  padding-left: ${theme.spacing.x2};
  white-space: nowrap;
`;
const FilterChip = ({ disabled, label, onClick, swatchColor, swatchImageUrl, value, }) => {
    const filterChipButtonStyles = useMemo(() => css `
      ${styleUtils.buttonReset}
      ${theme.typeStyles.bodySmallStyles}
      ${theme.typeStyles.bodyBoldStyles}
      align-items: center;
      background-color: ${theme.colors.accent300};
      border-radius: ${theme.spacing.base};
      border: none;
      color: ${theme.colors.textPrimary};
      display: flex;
      height: ${styleUtils.rem(filterChipContainerHeight)};
      justify-content: center;
      padding-bottom: ${theme.spacing.x2};
      padding-left: ${theme.spacing.x2};
      padding-right: ${theme.spacing.x2};
      padding-top: ${theme.spacing.x2};
      white-space: nowrap;

      ${!disabled && css `
        &:hover {
          cursor: pointer;
          background-color: ${theme.colors.accent400};

          @media (pointer: coarse) {
            -webkit-tap-highlight-color: transparent;
            background-color: ${theme.colors.accent300};
          }
        }
      `}

      ${disabled && css `
        background-color: ${theme.colors.surfaceSystemDisabled};
        color: ${theme.colors.textDisabled};
      `}
    `, [
        disabled,
    ]);
    const swatchContainerStyles = useMemo(() => (css `
        padding-bottom: ${theme.spacing.none};
        padding-left: ${theme.spacing.base};
        padding-right: ${theme.spacing.base};
        padding-top: ${theme.spacing.none};
        ${disabled && css `
          opacity: 0.3;
        `}
      `), [
        disabled,
    ]);
    const handleOnClick = useCallback(() => {
        if (onClick !== undefined) {
            onClick(value);
        }
    }, [
        onClick,
        value,
    ]);
    return (_jsxs("button", Object.assign({ css: filterChipButtonStyles, disabled: disabled, onClick: handleOnClick, type: "button" }, { children: [(swatchColor
                || swatchImageUrl)
                && (_jsx(SwatchPickerContext.Provider, Object.assign({ value: {
                        shape: 'CIRCLE',
                        size: 'medium',
                    } }, { children: _jsx("span", Object.assign({ css: swatchContainerStyles }, { children: _jsx(SwatchPickerDesign, { color: swatchColor, "data-testid": "swatch-picker-design", imageUrl: swatchImageUrl }) })) }))), _jsx("span", Object.assign({ css: labelStyles }, { children: label })), _jsx("span", Object.assign({ css: iconContainerStyles }, { children: _jsx(Icon, { size: "extraSmall", type: "close" }) }))] })));
};
const MemoizedFilterChip = memo(FilterChip);
export { MemoizedFilterChip as FilterChip };
// MC-1068 Temporary hack for Storybook.
export default MemoizedFilterChip;
